var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoDemo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 44,
    viewBox: "0 0 46 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0585 35.5801C23.367 40.3042 19.289 43.2941 14.7624 43.2941C6.60638 43.2941 0 33.6067 0 21.647C0 9.68735 6.60638 0 14.7624 0C19.289 0 23.367 2.98992 26.0585 7.714C23.2854 11.0029 21.5319 16.026 21.5319 21.647C21.5319 27.2681 23.2854 32.351 26.0585 35.5801Z",
    fill: "#004CC4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0001 21.6485C46.0001 31.5751 40.5355 39.5881 33.766 39.5881C30.8706 39.5881 28.1792 38.0931 26.0586 35.5816C28.2199 31.8143 29.5249 26.9706 29.5249 21.6485C29.5249 16.3265 28.2199 11.4828 26.0586 7.71548C28.1792 5.20395 30.8299 3.70898 33.766 3.70898C40.5355 3.70898 46.0001 11.7818 46.0001 21.6485Z",
    fill: "#009FE3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDemo);
export default __webpack_public_path__ + "static/media/logo_demo.ae269c4e7d73f97f3e174e0496897058.svg";
export { ForwardRef as ReactComponent };